import { CollectionState } from '../state';
import { useEffect, useState } from 'react';
import {
  CollectionDatasetSyncState,
  Dataset,
} from '../state/CollectionDatasetSync/CollectionDatasetSyncState';

export interface UseCollectionDatasetSyncProps {
  dataset: Dataset;
  onDatasetChange?: (dataset: any) => void;
}

export function useCollectionDatasetSync(
  collection: CollectionState<any>,
  props: UseCollectionDatasetSyncProps,
) {
  const [state] = useState(
    () =>
      new CollectionDatasetSyncState({
        dataset: props.dataset,
        onDatasetChange: props.onDatasetChange,
        collection,
      }),
  );

  state.onDatasetChange = props.onDatasetChange;

  useEffect(() => state.init(), [state]);

  useEffect(() => {
    state.setDataset(props.dataset);
  }, [props.dataset]);
}
